import React, { useEffect, useState } from "react";
import { Row, Card, Stack, Col, Carousel } from "react-bootstrap";
import "./../../App.css";
import ClipLoader from "react-spinners/ClipLoader";
import { useParams } from "react-router-dom";

const override = {
  display: "block",
  margin: "0 auto",
};

function timeSince(date) {
  var seconds = Math.floor((new Date() - date) / 1000);

  var daysRounded = Math.floor(seconds / (24 * 60 * 60));
  var hoursRounded = Math.floor(
    (seconds - daysRounded * 24 * 60 * 60) / (60 * 60)
  );

  var dayNotation = "dagen";
  var hoursNotation = "uren";

  if (daysRounded === 1) {
    dayNotation = "dag";
  }
  if (hoursNotation === 1) {
    hoursNotation = "uur";
  }

  return `${daysRounded} ${dayNotation}, ${hoursRounded} ${hoursNotation}`;
}

const LongRentals = () => {
  const [schade, setSchade] = useState([]);
  const [loading, setLoading] = useState(false);
  const { apiKey } = useParams();
  var longRentalCarousels = [];
  const animationDuration = 5000;

  const getSchade = async () => {
    setLoading(true);

    const resp = await fetch("api/longrentals/longrentals/" + apiKey);
    if (resp.ok) {
      const data = await resp.json();
      setSchade(data);
      setLoading(false);
    }
  };

  useEffect(() => {
    getSchade();

    const autoR = setInterval(() => {
      getSchade();
    }, 15 * 60 * 1000);

    return () => clearInterval(autoR);
  }, []);

  const StatusNumberBg = [
    "danger",
    "warning",
    "success",
    "dark",
    "secondary",
    "info",
  ];
  const CrappyTextFix = ["light", "dark", "light", "light", "dark", "dark"];

  function splitItems() {
    const chunkSize = 3;

    for (var i = 0; i < schade.length; i += chunkSize) {
      const damageCards = schade.slice(i, i + chunkSize);
      longRentalCarousels.push(damageCards);
    }
  }

  splitItems();

  return (
    <>
      {loading ? (
        <div>
          <ClipLoader
            color="#5b36d6"
            loading={loading}
            cssOverride={override}
            speedMultiplier="0.8"
            size={35}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      ) : (
        <Row>
          <Col>
            <Card>
              <Card.Header className="fw-bold text-center fs-5">
                Lange ritten
              </Card.Header>
              <Card.Body>
                <Carousel controls={false} indicators={false}>
                  {longRentalCarousels.map((name, key) => (
                    <Carousel.Item
                      key={"Long" + key}
                      interval={animationDuration}
                    >
                      <Col>
                        <Stack
                          direction="horizontal"
                          gap={2}
                          className="justify-content-top wrapper"
                        >
                          <Stack
                            direction="horizontal"
                            gap={3}
                            className="justify-content-top wrapper"
                          >
                            {name.map((s) => (
                              <Card
                                key={s.id}
                                border={StatusNumberBg[s.status]}
                                bg={StatusNumberBg[s.status]}
                                text={CrappyTextFix[s.status]}
                                style={{ height: "100%" }}
                              >
                                <Card.Header className="fw-bold text-center fs-5">
                                  {s.droppointName}
                                </Card.Header>
                                <Card.Body
                                  className="text-dark"
                                  style={{
                                    backgroundColor:
                                      "rgba(255, 255, 255, 0.55)",
                                  }}
                                >
                                  <Card.Text>
                                    <li style={{ listStyleType: "none" }}>
                                      <b>Fiets:</b> {s.vehicleCode}
                                    </li>
                                    <li style={{ listStyleType: "none" }}>
                                      <b>Duur:</b>{" "}
                                      {timeSince(Date.parse(s.started))}
                                    </li>
                                  </Card.Text>
                                </Card.Body>
                              </Card>
                            ))}
                          </Stack>
                        </Stack>
                      </Col>
                    </Carousel.Item>
                  ))}
                </Carousel>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
    </>
  );
};

export default LongRentals;
